import React from 'react'
import classnames from 'classnames'
import classes from './styles.module.scss'

interface IGroupProps {
  children?: React.ReactNode
  gap?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  mt?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  mb?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  ml?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  mr?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  my?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  mx?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
  align?: 'start' | 'center' | 'end'
  justify?: 'start' | 'center' | 'end' | 'between' | 'around'
  className?: string // New prop for custom className
}

export const Group = (props: IGroupProps) => {
  const {
    children,
    gap,
    mt,
    mb,
    ml,
    mr,
    my,
    mx,
    align,
    justify,
    className // Destructure the className prop
  } = props

  return (
    <div
      className={classnames(
        classes.group,
        {
          [classes[`gap-${gap}`]]: gap,
          [classes[`mt-${mt}`]]: mt,
          [classes[`mb-${mb}`]]: mb,
          [classes[`ml-${ml}`]]: ml,
          [classes[`mr-${mr}`]]: mr,
          [classes[`my-${my}`]]: my,
          [classes[`mx-${mx}`]]: mx,
          [classes[`align-${align}`]]: align,
          [classes[`justify-${justify}`]]: justify,
        },
        className
      )}
    >
      {children}
    </div>
  )
}